import React, { useEffect, useState, useContext } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import TFObject from '../../components/TFObject';
import TFSkeleton from '../../components/Skeleton';


const Loan = ( { aid, uid, accts, viewing, loans, contacts, tasks, leadopps, files, offers, notes, lists, reviews, setCurrent } ) => {
    let params = useParams();
    const [ loaded, setLoaded ] = useState( false );
    const [ l, setLoan ] = useState( {
        details: {},
        leadopps: [],
        borrowers: [],
        tasks: [],
        reviews: [],
        gifts: [],
        notes: [],
        lists: [],
        offers: [],
        files: []
    } );
    const [ meta, setMeta ] = useState( {} );
    
    useEffect( () => {
        setCurrent( params.lid );
    }, [ params.lid, setCurrent ] );

    useEffect( () => {
        const l = loans[params.lid];

        if ( l && viewing.includes( l.aid ) ) {
            setLoan( prev => {
                return {
                    ...prev,
                    details: l,
                    borrowers: l.borrowers
                }
            } );
            setMeta( accts.find( f => f.id === l.aid )?.crm?.meta?.loan );
            setLoaded( true );
        } else {
            setLoaded( false );
        }
    }, [ params.lid, loans, viewing, accts ] );

    // Tasks
    useEffect( () => {
        const list = [];
        Object.keys( tasks ).forEach( t => {
            const yes = tasks[t]?.assoc?.find( f => f.lid === params.lid );
            if ( yes ) {
                list.push( tasks[t] );
            }
        } );
        setLoan( prev => {
            return {
                ...prev,
                tasks: list
            }
        } );
    }, [ params.lid, tasks ] );

    // Load lead opps
    useEffect( () => {
        const list = [];
        Object.keys( leadopps ).forEach( lo => {
            const yes = leadopps[lo]?.relationships?.find( f => f.lid === params.lid );
            if ( yes ) {
                console.log( 'pushing leadopp: ' + lo );
                list.push( { ...leadopps[lo], ...yes } );
            }
        } );
        list.sort( ( a, b ) => {
            const ad = new Date( a.oppDate + 'T12:00:00.000' );
            const bd = new Date( b.oppDate + 'T12:00:00.000' );
            return bd.getTime() - ad.getTime();
        } );
        setLoan( prev => {
            return {
                ...prev,
                leadopps: list
            }
        } );
    }, [ params.lid, leadopps ] );

    // Gifts
    // useEffect( () => {
    //     const list = [];
    //     Object.keys( gifts ).forEach( g => {
    //         const yes = gifts[g].recips.find( f => f.cid === params.cid );
    //         if ( yes ) {
    //             list.push( gifts[g] );
    //         }
    //     } );
    //     setContact( prev => {
    //         return {
    //             ...prev,
    //             gifts: list
    //         }
    //     } );
    // }, [ params.cid, gifts ] );

    // Notes
    useEffect( () => {
        const list = [];
        Object.keys( notes ).forEach( nid => {
            const n = notes[nid];
            if ( !n || !n.assoc ) {
                return;
            }
            const yes = n.assoc.find( f => f.lid === params.lid );
            if ( yes ) {
                list.push( n );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                const ad = new Date( a.createdDate.match( 'T' ) ? a.createdDate : a.createdDate + 'T12:00:00' );
                const bd = new Date( b.createdDate.match( 'T' ) ? b.createdDate : b.createdDate + 'T12:00:00' );
                return bd.getTime() - ad.getTime();
            } );
        }

        setLoan( prev => {
            return {
                ...prev,
                notes: list
            }
        } );
    }, [ params.lid, notes ] );

    // Reviews
    useEffect( () => {
        const list = [];
        Object.keys( reviews ).forEach( r => {
            const yes = reviews[r].assoc.find( f => f.lid === params.lid );
            if ( yes ) {
                list.push( reviews[r] );
            }
        } );
        setLoan( prev => {
            return {
                ...prev,
                reviews: list
            }
        } );
    }, [ params.lid, reviews ] );
    
    // Load files
    useEffect( () => {
        const list = [];
        Object.keys( files ).forEach( fid => {
            // console.log( 'processing comm: ' + cid );
            const f = files[fid];
            if ( f.lid === params.lid ) {
                list.push( f );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                if ( b.createdDate < a.createdDate ) {
                    return -1;
                }
                if ( a.createdDate < b.createdDate ) {
                    return 1;
                }
                return 0;
            } );
        }

        setLoan( prev => {
            return {
                ...prev,
                files: list
            }
        } );
    }, [ params.lid, files ] );

    // Load offers
    useEffect( () => {
        const list = [];
        Object.keys( offers ).forEach( oid => {
            // console.log( 'processing comm: ' + cid );
            const o = offers[oid];
            if ( o.lid === params.lid ) {
                list.push( o );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                if ( b.offerDate < a.offerDate ) {
                    return -1;
                }
                if ( a.offerDate < b.offerDate ) {
                    return 1;
                }
                return 0;
            } );
        }

        setLoan( prev => {
            return {
                ...prev,
                offers: list
            }
        } );
    }, [ params.lid, offers ] );

    // Load lists
    useEffect( () => {
        const list = [];
        Object.keys( lists ).forEach( gid => {
            const g = lists[gid];
            console.log( 'processing list: ', g );
            if ( !g || g.itemType !== 'loans' || !g.items || !g.items.length ) {
                return;
            }
    
            const yes = g.items.find( f => f === params.lid );
            if ( yes ) {
                list.push( g );
            }
        } );
        setLoan( prev => {
            return {
                ...prev,
                lists: list
            }
        } );
    }, [ params.lid, lists ] );

    useEffect( () => {
        document.title = `Third Floor - ${l?.details?.name}`;
    }, [ l ] );

    return (
        loaded ? (
            <TFObject key={params.lid} objType='loan' obj={l} oid={params.lid} objPick={meta.picklist} header={meta.header} details={meta.details} sidebar={meta.sidebar} />
        ) : (
            <TFSkeleton />
        )
        
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    // meta: state.user.meta.loan,
    accts: state.user.lists.accounts,
    viewing: state.user.viewing,
    // l: state.loans.current
    loans: state.loans.byId,
    contacts: state.contacts.byId,
    tasks: state.tasks.byId,
    leadopps: state.leadopps.byId,
    files: state.files.byId,
    offers: state.offers.byId,
    notes: state.notes.byId,
    lists: state.lists.byId,
    reviews: state.reviews.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
    setCurrent: dispatch.loans.setCurrent
} );
  
export default connect( mapProps, mapDispatch )( Loan );